import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinpimprichichwad() {



  const cardData =
  {
    keyword: 'Cab Service in Pimpri Chinchwad',
    heading: 'Sanavi Travels: Cab Service in Pimpri Chinchwad',
    headingDescription: 'Sanavi Travels offers reliable Cab Service in Pimpri Chinchwad, providing safe, comfortable, and convenient transportation for local travel, outstation trips, airport transfers, and corporate journeys. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free experience. With professional chauffeurs, flexible one-way and round-trip options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide doorstep pickup and drop services across Pimpri, Chinchwad, Wakad, Hinjewadi, Akurdi, Nigdi, and surrounding PCMC areas, making it ideal for daily travel, business trips, family outings, and religious visits. Choose Sanavi Travels for trusted cab services in Pimpri Chinchwad, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a proud symbol of Maratha valor. Once the administrative center of the Maratha Empire, the fort features massive stone walls, grand gateways like the Delhi Darwaza, and sprawling courtyards. The evening light-and-sound show narrates the glorious history of the Peshwas, making it a must-visit heritage attraction."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a nationally significant monument closely associated with India’s freedom movement. Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. Today, it houses a museum with personal belongings, photographs, and memorials, set amidst beautifully landscaped gardens that offer peace and reflection."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark. The richly adorned idol of Lord Ganesha attracts thousands of devotees daily, especially during Ganesh Chaturthi when grand celebrations take place. The temple trust is also known for its charitable and social initiatives."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort famous for the bravery of Tanaji Malusare and the legendary battle fought for Chhatrapati Shivaji Maharaj. The fort offers panoramic views of the Sahyadri ranges and Pune city. Trekking enthusiasts and history lovers visit it for its scenic beauty and historical significance."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in the heart of the city, it offers a calm and spiritual atmosphere, showcasing ancient Indian architectural excellence."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts representing India’s cultural and artistic heritage. From traditional musical instruments to household antiques and sculptures, the museum provides deep insight into India’s rich craftsmanship and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering breathtaking views of the city after climbing 103 stone steps. The hilltop temple complex, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati and is especially popular during sunrise and sunset."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from across the world. Known for meditation programs, wellness therapies, and peaceful gardens, it serves as a global center for mindfulness, relaxation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing water streams, wooden bridges, and lush greenery, it offers a serene escape for families, walkers, and photography enthusiasts."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure destination on the outskirts of Pune. Especially scenic during the monsoon season, it offers beautiful views of the reservoir and surrounding hills. The area is also a gateway to Sinhagad Fort and a favorite spot for evening outings."
  }
]
,



"services": [
{
"name": "Cab Service in Pimpri Chinchwad",
"description": "Cab Service in Pimpri Chinchwad provides dependable and professional taxi solutions for daily commuting, local travel, and long-distance journeys. With well-maintained vehicles, experienced drivers, and punctual service, it ensures a safe, comfortable, and convenient travel experience for residents, corporate clients, and tourists across the PCMC area."
},
{
"name": "Taxi Service PCMC",
"description": "Taxi Service PCMC offers reliable transportation for individuals, families, and business travelers. Easy availability, transparent pricing, and courteous drivers make this service ideal for local rides, city travel, and planned journeys within and outside Pimpri Chinchwad."
},
{
"name": "AC Cab PCMC",
"description": "AC Cab PCMC ensures a cool and comfortable ride with fully air-conditioned vehicles suitable for all seasons. Designed for comfort and convenience, these cabs are perfect for families, senior citizens, corporate travelers, and tourists seeking a relaxed journey."
},
{
"name": "Local Cab PCMC",
"description": "Local Cab PCMC provides convenient taxi services for short-distance travel, shopping trips, office commutes, and city sightseeing. Quick response times and professional drivers make local travel easy and hassle-free."
},
{
"name": "Outstation Cab PCMC",
"description": "Outstation Cab PCMC offers reliable long-distance taxi services to nearby cities and tourist destinations. Comfortable vehicles, skilled drivers, and flexible travel plans ensure a smooth and enjoyable outstation travel experience."
},
{
"name": "Affordable Cab PCMC",
"description": "Affordable Cab PCMC delivers budget-friendly taxi services without compromising on safety or comfort. Ideal for daily commuters, families, and group travelers, it combines economical fares with dependable service."
},
{
"name": "Chauffeur Driven Cab PCMC",
"description": "Chauffeur Driven Cab PCMC provides professional and trained drivers who handle navigation, traffic, and routes efficiently. This service ensures a stress-free and pleasant journey for business travel, events, and family outings."
},
{
"name": "Best Cab Service PCMC",
"description": "Best Cab Service PCMC is known for its punctuality, clean vehicles, and customer-focused approach. Suitable for local, airport, corporate, and outstation travel, it guarantees reliable and comfortable transportation every time."
},
{
"name": "Airport Cab PCMC",
"description": "Airport Cab PCMC offers timely pickup and drop services to and from Pune airport. With reliable scheduling, flight tracking, and professional drivers, it ensures a smooth and worry-free airport transfer experience."
},
{
"name": "Corporate Cab PCMC",
"description": "Corporate Cab PCMC provides efficient taxi solutions for offices, executives, meetings, and corporate events. Professional drivers, comfortable vehicles, and punctual service support smooth and professional business travel."
},
{
"name": "Tourist Cab PCMC",
"description": "Tourist Cab PCMC caters to travelers exploring Pimpri Chinchwad, Pune, and nearby attractions. Flexible itineraries, knowledgeable drivers, and comfortable cabs ensure an enjoyable and memorable sightseeing experience."
},
{
"name": "Online Cab Booking PCMC",
"description": "Online Cab Booking PCMC allows quick and easy cab reservations with instant confirmation. Multiple vehicle options, flexible scheduling, and a simple booking process help travelers plan their journeys efficiently."
},
{
"name": "Railway Pickup Cab PCMC",
"description": "Railway Pickup Cab PCMC provides prompt pickup and drop services from nearby railway stations. This service ensures seamless connectivity for passengers arriving or departing by train in the Pimpri Chinchwad area."
},
{
"name": "24x7 Taxi PCMC",
"description": "24x7 Taxi PCMC offers round-the-clock taxi services for emergencies, late-night travel, early-morning airport transfers, and unplanned journeys, ensuring reliable transportation at any hour."
},
{
"name": "Pimpri Chinchwad Travel Taxi",
"description": "Pimpri Chinchwad Travel Taxi provides complete taxi solutions for local and outstation journeys. Combining comfort, safety, affordability, and professional service, it caters to residents, tourists, and corporate travelers alike."
}
],
"tableData": [
["Cab Service in Pimpri Chinchwad", "Taxi Service PCMC"],
["AC Cab PCMC", "Local Cab PCMC"],
["Outstation Cab PCMC", "Affordable Cab PCMC"],
["Chauffeur Driven Cab PCMC", "Best Cab Service PCMC"],
["Airport Cab PCMC", "Corporate Cab PCMC"],
["Tourist Cab PCMC", "Online Cab Booking PCMC"],
["Railway Pickup Cab PCMC", "24x7 Taxi PCMC"],
["Pimpri Chinchwad Travel Taxi", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Pimpri Chinchwad with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Pimpri Chinchwad for local travel, airport transfers, business trips, and outstation journeys."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air-conditioned, and kept clean to ensure a smooth and pleasant ride in and around Pimpri Chinchwad."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are licensed, courteous, and well-versed with the Pimpri Chinchwad area to ensure safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Pimpri Chinchwad, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, full-day hires, airport transfers, and outstation cab packages as per your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Pimpri Chinchwad."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Pimpri Chinchwad?',
    answer: 'Yes, Sanavi Travels offers reliable cab services in Pimpri Chinchwad for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Pimpri Chinchwad?',
    answer: 'You can book a cab easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab rides are available in Pimpri Chinchwad?',
    answer: 'Sanavi Travels offers local rides, airport transfers, full-day hires, and outstation cab services.'
  },
  {
    question: 'Are the drivers experienced with routes in Pimpri Chinchwad?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Pimpri Chinchwad area and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Pimpri Chinchwad.'
  },
  {
    question: 'Is the cab service in Pimpri Chinchwad available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services in Pimpri Chinchwad to suit your schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Pimpri Chinchwad.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prasad Kulkarni',
    feedback: 'Booked a cab with Sanavi Travels in Pimpri Chinchwad—excellent service, clean car, and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shweta More',
    feedback: 'Great cab service in Pimpri Chinchwad with on-time pickup and comfortable journey. Highly recommended!',
    rating: 5
  }
];









































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cab Service in Pimpri-Chinchwad - Sanavi Travels",
  "description": "Sanavi Travels provides AC, local, and outstation cabs in Pimpri-Chinchwad for airport pickups, corporate travel, tourist trips, and railway station transfers. Affordable and reliable chauffeur-driven cab service with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "45"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Cab Service in Pimpri-Chinchwad | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides AC, local, and outstation cabs in Pimpri-Chinchwad for airport pickups, corporate travel, tourist trips, and railway station transfers. Affordable and reliable chauffeur-driven cab service with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/179.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinpimprichichwad;